<input [formControl]="control" [id]="field.key" [type]="field.type ? field.type : 'text'">